import { httpRequest } from "@services/http";
import { Debit } from "@models/debit.model";
import { DebitSerializer } from "@models/serializers/debitSerializer";

export class CommandDeleteDebit {
  async run(contractId: number, debitId: number): Promise<Debit> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/finance/contracts/${contractId}/debits/${debitId}/`;
    const response = await httpRequest<any>(url, { method: "DELETE" });
    return DebitSerializer.fromJson(response);
  }
}
